import { createRouter, createWebHistory } from 'vue-router';
import ChatGPT from './components/ChatGPT.vue'
import Login   from './components/Login.vue'

const routes = [
  {
    path: '/',
    name: 'chatgpt',
    component: ChatGPT
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
